

import PROFILE from "../Assets/gupta3.png";
import bg from '../Assets/Projects/bg_video.mp4';
import { useEffect, useState } from "react";
// import Typical from "react-typical";
import { TypeAnimation } from 'react-type-animation';
import { HiArrowNarrowRight } from "react-icons/hi";
import { Link } from "react-scroll";
import {
  FaGithub,
  FaLinkedinIn,
  FaInstagram,
  FaEnvelope,
  FaDownload,
} from "react-icons/fa";

const PREVIOUS_EXPERIENCE_MONTHS = 6;
const CURRENT_ROLE_START_DATE = new Date(2025, 9, 1);

const getCompletedMonths = (startDate, endDate) => {
  let months =
    (endDate.getFullYear() - startDate.getFullYear()) * 12 +
    endDate.getMonth() -
    startDate.getMonth();

  if (endDate.getDate() < startDate.getDate()) {
    months -= 1;
  }

  return Math.max(months, 0);
};

const getExperienceLabel = (currentDate) => {
  const totalMonths =
    PREVIOUS_EXPERIENCE_MONTHS +
    getCompletedMonths(CURRENT_ROLE_START_DATE, currentDate);
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;

  if (years >= 2 || months === 0) {
    return `${years}+ years`;
  }

  return `${years}.${months}+ years`;
};

const Home = () => {
  const [currentDate, setCurrentDate] = useState(() => new Date());

  useEffect(() => {
    const refreshExperience = window.setInterval(() => {
      setCurrentDate(new Date());
    }, 60 * 60 * 1000);

    return () => window.clearInterval(refreshExperience);
  }, []);

  const experience = getExperienceLabel(currentDate);

  return (
    <div name="home" className="w-full md:h-screen bg-[#010206] ">
      {/* <div className=" overlay absolute left-0 top-0 w-[100%] h-[100%] "> */}
      <div className=" overlay w-[100%] h-[80%]  bg-opacity-80 bg-black z-10  ">

        <video src={bg} loop autoPlay muted className="absolute inset-0 w-[100%] h-[117%]  object-cover opacity-20 bg-black -z-1" />
        {/* Container */}
        <div className="relative max-w-[1000px] mx-auto pb-3 flex flex-col justify-center items-center w-[100%] h-[100%]">

          <div className=" glassmorphism-container justify-center items-center grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-5">
            <div className="container justify-center  items-center">
              <p className=" text-2xl text-green-600 mt-10 ">Hii, my name is</p>
              <h1 className="text-3xl sm:text-4xl font-bold text-[#edf2ff]">
                Ranjan Kumar
              </h1>
              <h2 className="text-2xl sm:text-2xl font-bold text-[#f5f8ff]">
                I'm a{" "}
                <TypeAnimation

                  sequence={[
                    "AI Developer",
                    1000,
                    "MERN Developer",
                    1200,
                    "Full Stack Developer",
                    1000,
                    "Java Developer",
                    1000,
                    "Python Developer",
                    1000,
                    "Odoo Developer",
                    1100,
                  ]}
                  // wrapper="p"
                  // speed={50}
                  repeat={Infinity}
                />
              </h2>
              {/* <p className="text-white py-4 max-w-[700px]">
                I’m a Software Engineer with professional experience turning business needs into full-stack SaaS applications and AI-powered products. Using React.js, TypeScript, Python,Odoo and PostgreSQL, I build intuitive interfaces, robust REST APIs, and features that simplify everyday work, from LLM and intelligent search to workflow automation. With AWS, Docker, and CI/CD, I bring these solutions from development to deployment, keeping reliability and customer experience at the core.
              </p> */}
              <div className="my-5 max-w-[700px] overflow-x-auto border-2 border-white bg-[#010206]/80 shadow-[8px_8px_0_0_#22c55e]">
                <table className="w-full border-collapse text-left text-sm text-white sm:text-base">
                  <tbody>
                    <tr className="border-b border-white/40">
                      <th scope="row" className="w-2/5 border-r border-white/40 bg-white/10 px-3 py-3 font-semibold sm:px-4">
                        Current Designation
                      </th>
                      <td className="px-3 py-3 sm:px-4">Associate Software Developer L-1</td>
                    </tr>
                    <tr className="border-b border-white/40">
                      <th scope="row" className="border-r border-white/40 bg-white/10 px-3 py-3 font-semibold sm:px-4">
                        Current Employer
                      </th>
                      <td className="px-3 py-3 sm:px-4">Oodles Technology Pvt. Ltd.</td>
                    </tr>
                    <tr className="border-b border-white/40">
                      <th scope="row" className="border-r border-white/40 bg-white/10 px-3 py-3 font-semibold sm:px-4">
                        Experience
                      </th>
                      <td className="px-3 py-3 sm:px-4">{experience}</td>
                    </tr>
                    <tr>
                      <th scope="row" className="border-r border-white/40 bg-white/10 px-3 py-3 font-semibold sm:px-4">
                        Email
                      </th>
                      <td className="break-all px-3 py-3 sm:px-4">
                        <a className="hover:text-green-400" href="mailto:mail.guptaranjan@gmail.com">
                          mail.guptaranjan@gmail.com
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* <div className="flex flex-row gap-4">

                <Link to="contact" smooth={true} duration={500}>
                  <button className="text-white group border-2 px-4 py-2 my-1 flex items-center hover:bg-pink-600 hover:border-pink-600 rounded-xl">
                    Hire Me
                  </button>
                </Link>

                <Link to="projects" smooth={true} duration={500}>
                  <button className="text-white group border-2 px-4 py-2 my-1 flex items-center hover:bg-pink-600 hover:border-pink-600 rounded-xl">
                    View Work
                    <span className="group-hover:rotate-90 duration-300">
                      <HiArrowNarrowRight className="ml-3 " />
                    </span>
                  </button>
                </Link>
                <a href={Resume} download={Resume}>
                  <button className="text-white group border-2 px-4 py-2 my-1 flex items-center hover:bg-pink-600 hover:border-pink-600 duration-400 rounded-xl">
                    Get Resume
                    <span className="">
                      <FaDownload className="ml-3 " />
                    </span>
                  </button>
                </a>
              </div> */}


              <div className="flex flex-col items-center sm:flex-row sm:justify-center py-4">
                <div className="flex flex-row gap-4">
                  <Link to="projects" smooth={true} duration={500}>
                    <button className="whitespace-nowrap text-white group border-2 px-4 py-2 flex items-center hover:bg-pink-600 hover:border-pink-600 rounded-xl">
                      View Work
                      <span className="group-hover:rotate-90 duration-300">
                        <HiArrowNarrowRight className="ml-3" />
                      </span>
                    </button>
                  </Link>

                  <a href="/Ranjan_CV.pdf" download="Ranjan_CV.pdf">
                    <button className="whitespace-nowrap text-white group border-2 px-4 py-2 flex items-center hover:bg-pink-600 hover:border-pink-600 duration-400 rounded-xl">
                      Get Resume
                      <span>
                        <FaDownload className="ml-3" />
                      </span>
                    </button>
                  </a>
                </div>
                <Link to="contact" smooth={true} duration={500}>
                  <button className="text-white group border px-4 py-2 flex items-center bg-pink-600 hover:bg-pink-700 rounded-xl sm:ml-4 sm:mt-0 mt-4">
                    Hire Me
                  </button>
                </Link>
              </div>


              <div className="py-2 mt-3 text-white flex items-center justify-center text-3xl">
                <a href="https://github.com/ranjangupta4590" target="_blank" rel="noreferrer"><FaGithub className="mr-4 text-3xl hover:text-blue-400" /></a>
                <a href="https://www.linkedin.com/in/ranjan-kumar-2023s/" target="_blank" rel="noreferrer"><FaLinkedinIn className="mr-4 text-3xl hover:text-blue-400" /></a>
                <a href="https://www.instagram.com/ranjan_gupta_official/" target="_blank" rel="noreferrer"><FaInstagram className="mr-4 text-3xl hover:text-blue-400" /></a>
                <a href="mailto:mail.guptaranjan@gmail.com" target="_blank" rel="noreferrer"><FaEnvelope className="text-3xl hover:text-blue-400" /></a>
              </div>
            </div>

            {/* IMage Profile */}
            <div className="image py-4 mx-auto pr-8 justify-center items-center md:justify-center">
              {/* <div></div> */}
              <div className=" justify-center items-center z-200">
                <img
                  className="mx-auto h-75 w-75 "
                  src={PROFILE}
                  alt="profile"
                />


              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default Home;
